module.exports = "<p>The artist on<br><em>Another Body</em> from the <em>Lobe of the Lung Family</em> 2009</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio6/content.md
// module id = 853
// module chunks = 0